import { Box, Stack, TextField } from "@mui/material";
import { Dispatch, memo, SetStateAction, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";
import useFilter from "../../../../hooks/useFilter";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams {
  Document: string;
  EstablishmentCode: string;
  refresh?: boolean;
}

const translationPath =
  "page.4uSiteApp.consultationsAndLogs.beneficiarySituation.";

const MacroFilter: React.FC<IMacroFilterProps> = ({
  onFilterParams,
  filterParams,
}) => {
  const { filter, initialState, setFilter, cleanFilter } =
    useFilter(filterParams);
  const { t } = useTranslation();
  const [validationAttempted, setValidationAttempted] = useState(false);

  const documentError = useMemo(() => {
    if (!validationAttempted || filter.Document.trim()) return "";

    return t(translationPath + "errors.document_required") || "Obrigatorio";
  }, [filter.Document, t, validationAttempted]);

  const filterHandler = () => {
    if (!filter.Document.trim()) {
      setValidationAttempted(true);
      onFilterParams(initialState.current);
      return;
    }

    setValidationAttempted(false);
    onFilterParams(filter);
  };

  const cleanHandler = () => {
    setValidationAttempted(false);
    onFilterParams(initialState.current);
    cleanFilter();
  };

  return (
    <Stack flexDirection="row" gap={2} alignItems="flex-start">
      <Box sx={{ flex: "0 0 260px" }}>
        <TextField
          value={filter.Document}
          size="small"
          label={`${t(translationPath + "document") || "CPF"} *`}
          fullWidth
          error={Boolean(documentError)}
          helperText={documentError || " "}
          onChange={(event) => setFilter({ Document: event.target.value })}
        />
      </Box>

      <Box sx={{ flex: "0 0 260px" }}>
        <TextField
          value={filter.EstablishmentCode}
          size="small"
          label={t(translationPath + "establishment_code") || "Estabelecimento"}
          fullWidth
          helperText=" "
          onChange={(event) =>
            setFilter({ EstablishmentCode: event.target.value })
          }
        />
      </Box>

      <Box sx={{ pt: 0.25 }}>
        <FiltersActions
          onFilter={filterHandler}
          onClean={cleanHandler}
          showCleanBtn={Boolean(filter.Document || filter.EstablishmentCode)}
        />
      </Box>
    </Stack>
  );
};

export default memo(MacroFilter);
